import { PopoverButton } from '@headlessui/react';
import Link from 'next/link';

import type { NavbarItem } from '../types';

interface BasicElementProps {
  item: NavbarItem;
}

export function BasicGroupItemElement(props: BasicElementProps) {
  const { item } = props;

  const isLink = item.type === 'basic';
  if (!isLink && 'largeAction' in item) {
    return item.largeAction(item.name, item.icon);
  }

  return (
    <PopoverButton
      as={Link}
      target={'blank' in item ? '_blank' : undefined}
      href={'href' in item ? item.href : '#'}
      className="cursor-pointer group relative flex gap-x-6 rounded-lg p-3 text-sm/6 hover:bg-neutral-50"
    >
      {item.icon && (
        <div className="mt-1 flex size-11 flex-none items-center justify-center rounded-lg bg-neutral-50 group-hover:bg-white">
          <item.icon className="size-6 text-neutral-600 group-hover:text-primary-600" />
        </div>
      )}
      <div className="flex items-center font-semibold text-neutral-900">
        {item.name}
      </div>
    </PopoverButton>
  );
}
